<template>
  <header class="header">
    <nav class="nav">
      <ul class="nav-list">
        <li>
          <router-link
            to="/"
            class="nav-item"
            active-class="active"
          >Sobre</router-link>
        </li>
        <li>
          <router-link
            to="/projetos"
            class="nav-item"
            active-class="active"
          >Projetos</router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<style scoped>
.header {
  position: relative;
  z-index: 1000;
  width: 100%;
  padding: 16px 20px;
  font-family: "Corporate S WGL Demi", sans-serif;
  max-width: 1200px; /* Alinha o Header com o conteúdo */
  margin: 0 auto;
}

.nav {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-list {
  display: flex;
  list-style: none;
  gap: 16px;
  padding: 0;
  margin: 0;
}

.nav-item {
  text-decoration: none;
  font-size: 16px;
  color: #333;
  opacity: 0.5;
  font-weight: bold;
  transition: color 0.3s;
}

.nav-item:hover {
  color: #007bff;
}

.active {
  color: #121212;
  font-weight: bolder;
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
</style>
